import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import classnames from 'classnames'
import {
    forFeature,
    i18n,
} from '../../../validator'
import { fetchNews } from '../../news/fetch-news'
import { loadEvents as loadEventsFunc } from '../../../front/components/shared/events/helper'
import Configurator from '../../../configurator'
import LandingMainBox from '../../landing-main-box'
import LandingBox from '../../landing-box'
import LandingStatistics from './statistics'
import LandingTopEvents from './top-events-slider'
import Footer from '../../footer/footer-new'
import Navigator from '../../nav/index'
import RegistrationBanner from '../../info-page/parts/registration-banner'
import store, {
    DEFAULT_EVENTS_FRONT_STORE,
    EVENTS_FRONT_ELEMENTS,
} from '../../../admin/store'
import MobileStoreLink from '../../app-stores/mobile-store-link'
import {
    AVAILABLE_LANGUAGES,
    DEVICE_ANDROID,
    DEVICE_IOS,
} from '../../../consts'
import SocialBanner from '../../../admin/components/shared/social-banner'
import Link from '../../../front/components/shared/sn-link'
import LandingButtons from './landing-buttons'
import LandingMap from './landing-map'
import LandingHeader from './landing-header'
import EventListener, { withOptions } from 'react-event-listener'
import { Helmet } from 'react-helmet'

const sliderSettings = {
    autoplay: false,
    autoplaySpeed: 10000,
    dots: false,
    infinite: true,
    slidesPerRow: 1,
    speed: 500,
}

const landingHeaderHeight = 60

const NewsLimit = 5
const TopEventsTag = 1
const TopEventsLimit = 9
const loadEventsParams = {
    defaultTag: TopEventsTag,
    limit: TopEventsLimit,
}

@forFeature('SPORTNECT_LANDING')
@i18n()
class Landing extends Configurator {

    state = {
        socialBannerShowed: localStorage.getItem('socialBannerShowed') === 'true',
        scrolledDown: false,
    }

    /**
     * Load next top events
     * TODO If parameter isFilter is false, top events aren't downloaded. It is hotfix -> need fix
     * @returns {Promise<any>}
     */
    loadNextTopEvents = () => loadEventsFunc(loadEventsParams, null, true)

    componentDidMount() {
        EVENTS_FRONT_ELEMENTS.forEach(element => {
            store.dispatch({
                type: 'EVENTS_SET_DATA',
                element: element,
                data: DEFAULT_EVENTS_FRONT_STORE,
            })
        })

        fetchNews(false, NewsLimit)
    }

    /**
     * Render slide for slider with links to AppStore and GooglePlay
     * @return {*}
     */
    renderMobileAppsSlide = () => {
        const { t } = this.props

        return (
            <div className="container Landing-blog-slider__item px-4">
                <div className="row p-5">
                    <div className="col-md-5 col-sm-12">
                        <div className="Landing-blog-slider__content--mobile">
                            <div className="Landing-blog-slider__title--mobile">{t('landingBlogSliderTitle')}</div>
                            <div className="Landing-blog-slider__subtext--mobile">{t('landingBlogSliderSubtitle')}</div>
                            <div className="pb-5 pb-md-0">
                                <MobileStoreLink forDevice={DEVICE_IOS} className="d-inline-block" linkClassName="Landing-blog-slider__button--mobile" />
                                <MobileStoreLink forDevice={DEVICE_ANDROID} className="d-inline-block" linkClassName="Landing-blog-slider__button--mobile" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 col-sm-12">
                        <img src="/images/landing/sn-landing-page-mobile.png" alt="" className="Landing-blog-slider__image--mobile" />
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Render slide for slider with blog post
     * @param {Object} item
     * @return {*}
     */
    renderBlogSlide = item => {
        const des = {
            id: item.id,
            name: item.name,
            perex: item.perex,
            photo: item?.mainPhoto?.data?.image_path,
            slug: item.slug,
        }

        const { t } = this.props

        return (
            <div className="container Landing-blog-slider__item" key={des.id}>
                <div className="row w-100">
                    <div className="col-md-7 col-sm-12">
                        <img src={des.photo} alt="" className="Landing-blog-slider__image" />
                    </div>
                    <div className="col-md-5 col-sm-12">
                        <div className="Landing-blog-slider__content">
                            <div className="Landing-blog-slider__title">{des.name}</div>
                            <div className="Landing-blog-slider__subtext" dangerouslySetInnerHTML={{ __html: des.perex }}/>
                            <div>
                                <Link to={`/aktuality/${des.slug}`} className="btn btn-color-brand btn-circle btn-lg">{t('showMore')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Render slider
     * @return {*}
     */
    renderSlider = () => {
        const { news } = this.props

        return (
            <div className="Landing-blog-slider container-fluid">
                <Slider {...sliderSettings}>
                    {this.renderMobileAppsSlide()}
                    {news && (Object.values(news).map(item => this.renderBlogSlide(item)))}
                </Slider>
            </div>
        )
    }

    render() {
        const {
            socialBannerShowed,
            scrolledDown,
        } = this.state

        const {
            topEvents: {
                events,
            },
            t,
        } = this.props

        const eventsValues = events ? Object.values(events) : []
        const scrolledPage = scrolledDown

        return (
            <Fragment>

                <EventListener
                    target="window"
                    onScroll={withOptions(() => this.setState(
                        { scrolledDown: this.getScrollY() > landingHeaderHeight }
                    ), {
                        passive: true,
                        capture: false,
                    })}
                />

                <LandingHeader
                    className={classnames({
                        'landing-header--visible': !scrolledPage && !this.isResponsive(),
                        'landing-header--notvisible': scrolledPage || this.isResponsive(),
                    })}
                />

                <Navigator
                    className={classnames({
                        'landing-header--visible': scrolledPage || this.isResponsive(),
                        'landing-header--notvisible': !scrolledPage && !this.isResponsive(),
                    })}
                />

                <LandingMainBox />

                <LandingButtons />

                {/*@TODO - temporarily hidden */}
                {false && <RegistrationBanner
                    title={t('landingBoxRegisterBannerTitle')}
                    buttonText={t('joinIn')}
                />}

                <LandingMap />

                <LandingBox
                    boxTitle={t('landingBoxSportnectScoreBy2017')}
                    boxInverseBg={true}
                >
                    <LandingStatistics />
                </LandingBox>

                {/*@TODO - temporarily hidden */}
                {false && events && eventsValues.length > 0 && (
                    <LandingBox boxTitle={t('landingBoxTopOrSportEvents')}>
                        <LandingTopEvents
                            widescreenSlider={eventsValues.length > 6}
                            events={events}
                        />
                    </LandingBox>
                )}

                <LandingBox
                    bgWhite
                    className="landing-slider min-h-65vh d-flex flex-column justify-content-center"
                >
                    {this.renderSlider()}
                </LandingBox>

                {!socialBannerShowed &&
                    <SocialBanner />
                }

                <Footer />

                <Helmet>
                    {AVAILABLE_LANGUAGES.map(lang => (
                        <link key={lang} rel="alternate" href={`${this.config.REACT_APP_FRONTEND_URL}/${lang}`} hrefLang={lang} />
                    ))}
                    <link rel="alternate" href={`${this.config.REACT_APP_FRONTEND_URL}`} hrefLang="x-default" />
                </Helmet>

            </Fragment>
        )
    }
}

export default connect(state => ({
    news: state.app.news.data,
    topEvents: state.eventsFront.events,
}))(Landing)
